var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17.5H14M10 13.5H14M10 9.5H14M13 2H11M18 17.2V9.8C18 8.11984 18 7.27976 17.673 6.63803C17.3854 6.07354 16.9265 5.6146 16.362 5.32698C15.7202 5 14.8802 5 13.2 5H10.8C9.11984 5 8.27976 5 7.63803 5.32698C7.07354 5.6146 6.6146 6.07354 6.32698 6.63803C6 7.27976 6 8.11984 6 9.8L6 17.2C6 18.8802 6 19.7202 6.32698 20.362C6.6146 20.9265 7.07354 21.3854 7.63803 21.673C8.27976 22 9.11984 22 10.8 22H13.2C14.8802 22 15.7202 22 16.362 21.673C16.9265 21.3854 17.3854 20.9265 17.673 20.362C18 19.7202 18 18.8802 18 17.2Z",
    stroke: "#87C8E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryMini);
export default __webpack_public_path__ + "static/media/batteryMini.0817be13640960184095d6d0ef71958f.svg";
export { ForwardRef as ReactComponent };